import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-macros-wrapper" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "action-buttons" }

import { VButton, VButtonDropdown } from "@/components";
import { computed, ref, watch } from "vue";
import store from "@/store";
import { kebabCase } from "lodash";
import { getRandomId } from "@/mixins/global.mixin";

interface Props {
  value?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VButtonDropdownMacros',
  props: {
    value: { default: "" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const key = ref(getRandomId());
const macrosesInUrl = ref([]);
const emit = __emit;
const macrosOptions = computed(() => store.getters["campaign/macrosOptions"]);
const getMacros = async () => await store.dispatch("campaign/getMacros");

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

const divideUrlOnParams = () => {
  macrosesInUrl.value = [];

  if (props.value.length && isValidUrl(props.value)) {
    let addr = new URL(props.value);

    for (const p of addr.searchParams) {
      let macrosCode = "[" + p[0] + "]";

      if (!macrosesInUrl.value.includes(macrosCode)) {
        macrosesInUrl.value.push(macrosCode);
      }
    }
  }
};

const onClickMacros = (macrosCode: string) => {
  return () => {
    if (props.value.length && isValidUrl(props.value)) {
      let ampOrQuestSign = "/?";

      if (props.value.endsWith("/")) {
        ampOrQuestSign = "?";
      }

      if (macrosesInUrl.value.length) {
        ampOrQuestSign = "&";
      }

      const cleanCode = macrosCode.replace("[", "").replace("]", "");
      const addMacroParam = ampOrQuestSign + cleanCode + "=" + macrosCode;

      if (!macrosesInUrl.value.includes(macrosCode)) {
        macrosesInUrl.value.push(macrosCode);
      }

      emit("input", props.value + addMacroParam);
    }
  };
};

watch(() => props.value, divideUrlOnParams);

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_unref(VButtonDropdown), {
      ref: "dropdown",
      "dropdown-icon": false,
      variant: false,
      "list-x-position": "right",
      "data-cy": "add-macros-link",
      class: "macros-info",
      text: _ctx.$t('title.addMacros')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macrosOptions.value, (element, elementIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: elementIndex,
              class: "macros-element"
            }, [
              _withDirectives((_openBlock(), _createBlock(_unref(VButton), {
                key: key.value,
                "data-cy": `macros-element-${_unref(kebabCase)(element.code)}`,
                size: "sm",
                variant: macrosesInUrl.value.includes(element.code) ? 'active' : 'primary',
                text: element.code
              }, null, 8, ["data-cy", "variant", "text"])), [
                [_directive_touch, onClickMacros(element.code)]
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(VButton), {
            text: "Close",
            onClick: _ctx.$refs.dropdown.hide
          }, null, 8, ["onClick"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["text"])), [
      [_directive_touch, getMacros]
    ])
  ]))
}
}

})